import { BaseCameraMouseWheelInput, serialize } from '@babylonjs/core';
import { Flat2DCamera } from 'Framework/Components/Controls/XView/Cameras';

export class ZoomAndPanMouseInput extends BaseCameraMouseWheelInput {
    /**
     * Called for each rendered frame.
     */
    public checkInputs(): void {
        if (this._wheelDeltaX === 0 && this._wheelDeltaY === 0 && this._wheelDeltaZ == 0) {
            return;
        }

        this.camera.inertialRadiusOffset += this._wheelDeltaY / this.angularPinchSensibility;

        // Call the base class implementation to handle observers and do cleanup.
        super.checkInputs();
    }

    public camera: Flat2DCamera;

    @serialize()
    public angularPinchSensibility = 600.0;
}